import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd'; 
import { ModalDescriptionListComponent } from './modal-description-list/modal-description-list.component';
import { BcacButtonModule } from 'bcac-lib/base-component/currency/bcac-button';
import { ModalFormComponent } from './modal-form/modal-form.component';



@NgModule({
  declarations: [ModalDescriptionListComponent, ModalFormComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule,
    BcacButtonModule
  ],
  exports: [
    ModalDescriptionListComponent,
    ModalFormComponent
  ]
})
export class BcacModalModule { }
